<nz-layout>
  <nz-content>
    @if (activeCategoryModule; as cm) {
      @if (cm.path === componentPaths.balanceAndGait) {
        <app-berg-and-gait-questionnaire
          [id]="cm.path"
          [modules]="cm.childModules"
          [(selectedOption)]="selectedOption"
          [readonlyMode]="readonlyMode"
          [overviewItemsByTemplateId]="overviewItemsByTemplateId"
          [overviewLoading]="isOverviewLoading"
          [overviewError]="overviewError"
          (overviewRefreshRequested)="handleOverviewRefreshRequested()"
        />
      }
      @if (cm.path === componentPaths.neurodegenerativeDisorders) {
        <app-neurodegenerative-disorders-questionnaire
          [id]="cm.path"
          [modules]="cm.childModules"
          [(selectedOption)]="selectedOption"
          [readonlyMode]="readonlyMode"
          [overviewItemsByTemplateId]="overviewItemsByTemplateId"
          [overviewLoading]="isOverviewLoading"
          [overviewError]="overviewError"
          (overviewRefreshRequested)="handleOverviewRefreshRequested()"
        />
      }
      @if (cm.path === componentPaths.strokeAndBrainInjury) {
        <app-stroke-and-brain-injury-questionnaire
          [id]="cm.path"
          [modules]="cm.childModules"
          [(selectedOption)]="selectedOption"
          [readonlyMode]="readonlyMode"
          [overviewItemsByTemplateId]="overviewItemsByTemplateId"
          [overviewLoading]="isOverviewLoading"
          [overviewError]="overviewError"
          (overviewRefreshRequested)="handleOverviewRefreshRequested()"
        />
      }
      @if (cm.path === componentPaths.depressionAndAnxiety) {
        <app-depression-and-anxiety-questionnaire
          [id]="cm.path"
          [modules]="cm.childModules"
          [(selectedOption)]="selectedOption"
          [readonlyMode]="readonlyMode"
          [overviewItemsByTemplateId]="overviewItemsByTemplateId"
          [overviewLoading]="isOverviewLoading"
          [overviewError]="overviewError"
          (overviewRefreshRequested)="handleOverviewRefreshRequested()"
        />
      }
      @if (cm.path === componentPaths.general) {
        <app-general-questionnaire
          [id]="cm.path"
          [modules]="cm.childModules"
          [(selectedOption)]="selectedOption"
          [readonlyMode]="readonlyMode"
          [overviewItemsByTemplateId]="overviewItemsByTemplateId"
          [overviewLoading]="isOverviewLoading"
          [overviewError]="overviewError"
          (overviewRefreshRequested)="handleOverviewRefreshRequested()"
        />
      }
    }
  </nz-content>
</nz-layout>
